<template>
	<div id="page">

		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
					اشخاص و موسسات
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>

			<div class="card card-style mb-2">
				<div class="p-3 d-flex">
					<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
						<i class="fa fa-filter text-white"></i>
					</button>
					<div class="filter-row-scrollable">

					</div>
				</div>

			</div>
			<div class="card card-style mb-2" v-for="task in PersonList" :key="task.personId">
				<div class="list-group list-custom-small list-icon-0">
					<router-link :to="{ name: 'EditPerson', params: { personId: task.personId  } }" href="#" class="list-group-div py-2 px-3">
						<div>
							<b class="font-15 text-dark">{{task.title}}</b>
						</div>
						<div class="d-flex justify-content-between">
							<div>
								<i class="fa fa-hashtag color-blue2-dark"></i>
								<span class="text-muted">{{task.code}}</span>
							</div>
							<span class="font-weight-lighter text-muted">{{task.personGroupTitle}}</span>
						</div>

					</router-link>
				</div>
			</div>
			<div class="card card-style" v-if="Loading==false && NoMoreData==false && PersonList.length>0">
				<div class="content">
					<div class="d-flex justify-content-center w-100">
						<button class="btn btn-outline-info rounded-m" @click="getNextPageForPersonList">نمایش بیشتر</button>
					</div>
				</div>
			</div>
			<!--<div class="card card-style" v-if="Loading">
			<div class="content">
				<div class="d-flex justify-content-center w-100 py-5">
					<div class="spinner-border color-magenta2-dark" role="status"></div>
				</div>
			</div>
		</div>-->
			<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
				<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
					<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
				</div>
			</transition>
		</div>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
				<router-link to="/CreatePerson">
					<div class="icon icon-m rounded-m color-white bg-green2-light">
						<i class="fa fa-plus"></i>
					</div>
				</router-link>
			</div>
		</transition>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'EditPerson', params: { personId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
					<a href="#" @click="deletePerson" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></a>

				</div>
				<div class="clear"></div>
			</div>
		</div>
		<div id="searchModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">جستجو</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">
						<div class="w-100 search-box rounded-m position-relative mb-3">
							<i class="fa fa-search pr-3"></i>
							<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
						</div>

						<button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
							<i class="fa fa-search ml-2"></i>
							جستجو
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>



</template>

<script>
	import VueSimpleAlert from "vue3-simple-alert";
	export default {
		data() {
			return {
				page: 1,
				searchKey: "",
				selectedWorkId: 0,
				pageLoaded: false
			};
		},
		computed: {
			PersonList() {
				return this.$store.getters.GetPersonList;
			},
			Loading() {
				return this.$store.getters.GetLoading;
			},
			NoMoreData() {
				return this.$store.getters.GetPersonNoMoreData;
			}
		},

		created() {
			console.log(this.NoMoreData);

			this.$store.dispatch("GetPersonListFromServerForIndex", {
				pageId: this.page,
				text: this.searchKey
			});
		},
		methods: {
			showAddButton() {
				this.pageLoaded = true;

			},
			showMenu(personId) {
				this.selectedWorkId = personId
			},

			deletePerson() {
				VueSimpleAlert.confirm("آیا مایل به حذف این فعالیت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$http.get("Person/Delete?id=" + this.selectedWorkId)
						.then(data => {
							var res = data.data;
							if (res.includes("حذف شد")) {
								this.showSuccessMessage("با موفقیت حذف شد.");
								this.$router.go();

							}
							else {
								this.showErrorMessage(res);
							}


						});
				});
			},
			openDetails(personId) {
				this.$router.push({ name: 'EditPerson', params: { personId: personId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
			getNextPageForPersonList() {

				this.page++;
				console.log(this.page);
				this.$store.dispatch("GetPersonListFromServerForIndex", {
					pageId: this.page,
					text: this.searchKey
				});
			},
			filterList() {
				this.page = 1;
				this.$store.dispatch("GetPersonListFromServerForIndex", {
					pageId: this.page,
					text: this.searchKey
				});
			},
		},
		mounted() {
			console.log("mounted");
			this.showAddButton();
			// this.getNextPageForPersonList();


		}
	};
</script>
